<template>
  <v-container class="wrapper-send-message pa-0">
    <v-container
      v-if="filePreviews != null && filePreviews.length > 0"
      class="wrapper-attachment pa-0"
    >
      <!--image-->
      <div class="d-flex align-center gap-2" style="flex-wrap: wrap">
        <div
          v-for="(file, index) in filePreviews"
          :key="index"
          v-if="resolveImgExtension(file.type)"
          class="wrapper-images"
        >
          <img :src="file.preview" class="attached-img" />
          <div class="close-btn img" @click="removeItem(index)">
            <v-icon color="#fff" style="font-size: 18px !important">mdi-close</v-icon>
          </div>
        </div>
      </div>
      <!--document-->
      <div class="d-flex align-center" style="flex-wrap: wrap; column-gap: 1rem">
        <div
          v-for="(file, index) in filePreviews"
          :key="index"
          class="d-flex align-center gap-2 wrapper-files mb-3"
          v-if="resolveDocExtension(file.type)"
        >
          <img
            v-if="file.name.includes('pdf')"
            src="https://cdn-icons-png.flaticon.com/512/11180/11180756.png"
            class="attached-doc"
          />
          <img
            v-if="file.name.includes('xlsx')"
            src="@/assets/ticket/xlsx.png"
            class="attached-doc"
          />
          <div class="close-btn doc" @click="removeItem(index)">
            <v-icon color="#fff" style="font-size: 18px !important">mdi-close</v-icon>
          </div>
          <v-card-text class="pa-0 text-body-1">{{ file.name }}</v-card-text>
        </div>
      </div>
    </v-container>
    <v-container class="send-message-bar d-flex align-end gap-2 pa-0">
      <v-btn
        v-if="isTicketSelected || messages.length > 0"
        outlined
        custom
        dense
        height="28"
        color="primary"
        class="send-message-btn send-message-btn--submit"
        @click="submitBtn"
        :loading="loading"
      >
        <my-icon :name="'submit-icon'" :width="16" :height="18" />
      </v-btn>
      <v-btn
        v-if="!isTicketSelected && messages.length == 0"
        outlined
        custom
        dense
        height="28"
        color="primary"
        class="send-message-btn send-message-btn--submit"
        @click="submitBtn"
        :loading="loading"
      >
        <my-icon :name="'submit-icon'" :width="16" :height="18" />
        <span class="pr-2">{{ $t("submit ticket") }}</span>
      </v-btn>
      <textarea
        ref="messageInput"
        :placeholder="
          isTicketStateClosed ||
          (selectedTicket != null && selectedTicket.state == 'close')
            ? $t('closed')
            : $t('write the message')
        "
        v-model="message"
        @keydown="submit"
        class="message-input flex-fill"
        :rows="rows"
        @input="adjustRows"
        :disabled="
          isTicketStateClosed ||
          (selectedTicket != null && selectedTicket.state == 'close')
        "
      >
      </textarea>
      <v-btn
        v-if="canOpenConversation"
        custom
        outlined
        dense
        height="28"
        class="send-message-btn ticket-conversation-btn"
        @click="openTicketConversation"
      >
        <my-icon
          :name="'chat-comment'"
          :width="18"
          :height="18"
          :stroke="$vuetify.theme.isDark ? '#fff' : '#030303'"
        />
      </v-btn>
      <v-menu top offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            custom
            outlined
            dense
            height="28"
            class="send-message-btn send-message-btn--attach"
            v-bind="attrs"
            v-on="on"
            :disabled="
              isTicketStateClosed ||
              (selectedTicket != null && selectedTicket.state == 'close')
            "
          >
            <my-icon
              :name="'attachment-icon'"
              :width="18"
              :height="18"
              :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
            />
          </v-btn>
        </template>
        <v-list class="px-4">
          <v-list-item class="d-flex align-center justify-space-between pa-0">
            <v-card-text class="text-heading-5 pa-0 pl-2">{{ $t("file") }}</v-card-text>
            <v-file-input
              style="display: none"
              ref="fileInput"
              v-model="files"
              multiple
              @change="onAttach"
            >
            </v-file-input>
            <v-btn custom outlined @click="triggerFileInput">
              <my-icon
                :name="'document2-icon'"
                :width="20"
                :height="20"
                :stroke="$vuetify.theme.isDark ? '#fff' : '#000'"
              />
            </v-btn>
          </v-list-item>
          <!-- <v-list-item class="d-flex align-center justify-space-between pa-0">
                        <v-card-text class="text-heading-5 pa-0 pl-2">{{ $t('text') }}</v-card-text>
                        <v-btn
                            custom
                            outlined
                        >
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.75 4.5752H2.25M15.75 9.0752H2.25M11.325 13.5002H2.25" stroke="#030303" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </v-btn>
                    </v-list-item> -->
          <!-- <v-list-item class="d-flex align-center justify-space-between pa-0">
                        <v-card-text class="text-heading-5 pa-0 pl-2">{{ $t('video') }}</v-card-text>
                        <v-btn
                            custom
                            outlined
                        >
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.00001 3.99001H4.57126C4.21667 3.99001 3.86557 4.05995 3.53806 4.19582C3.21054 4.33169 2.91304 4.53084 2.6626 4.78184C2.41215 5.03285 2.21367 5.33079 2.07852 5.65861C1.94338 5.98642 1.87422 6.33768 1.87501 6.69226V11.3138C1.87501 12.0288 2.15908 12.7146 2.66472 13.2203C2.91509 13.4707 3.21232 13.6693 3.53945 13.8048C3.86657 13.9403 4.21718 14.01 4.57126 14.01H9.00001C9.7151 14.01 10.4009 13.7259 10.9065 13.2203C11.4122 12.7146 11.6963 12.0288 11.6963 11.3138V6.69301C11.6973 6.33827 11.6284 5.98681 11.4934 5.65878C11.3584 5.33074 11.1599 5.03259 10.9094 4.7814C10.6589 4.53022 10.3613 4.33094 10.0337 4.19501C9.70601 4.05908 9.35474 3.98916 9.00001 3.98926M16.125 7.07851V10.9298C16.125 11.1173 16.0718 11.3018 15.9713 11.4608C15.8695 11.6202 15.7254 11.7482 15.555 11.8305C15.3858 11.9152 15.1952 11.9476 15.0075 11.9235C14.8225 11.9013 14.647 11.8293 14.4998 11.715L12.081 9.77401C11.9648 9.67841 11.8709 9.55862 11.8057 9.42301C11.7406 9.28739 11.7058 9.1392 11.7038 8.98876C11.7038 8.83876 11.7375 8.69101 11.8035 8.55751C11.8725 8.43151 11.967 8.32126 12.081 8.23351L14.4998 6.30826C14.647 6.19354 14.8229 6.12143 15.0083 6.09976C15.1958 6.07576 15.3863 6.10801 15.555 6.19201C15.7228 6.27252 15.8649 6.39802 15.9655 6.55455C16.0662 6.71107 16.1214 6.89246 16.125 7.07851Z" stroke="#030303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </v-btn>
                    </v-list-item> -->
          <v-list-item class="d-flex align-center justify-space-between pa-0">
            <v-card-text class="text-heading-5 pa-0 pl-2">{{ $t("image") }}</v-card-text>
            <v-file-input
              style="display: none"
              ref="fileInput"
              v-model="files"
              multiple
              @change="onAttach"
            >
            </v-file-input>
            <v-btn custom outlined @click="triggerFileInput">
              <my-icon
                :name="'image-icon'"
                :width="18"
                :height="18"
                :stroke="$vuetify.theme.isDark ? '#fff' : '#030303'"
              />
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-container>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import MyIcon from "../../../../components/general/icon/MyIcon.vue";
export default {
  components: { MyIcon },
  props: {
    isTicketSelected: Boolean,
    messages: Array,
    isFormValid: Boolean,
    toggleSelectionTicket: Boolean,
    isMessageSend: Boolean,
    isTicketCanceled: Boolean,
    isTicketStateClosed: Boolean,
    selectedTicket: Object,
    stopLoading: Boolean,
  },
  data() {
    return {
      message: null,
      files: [],
      allFiles: [],
      filePreviews: [],
      resolvedMessageAction: {
        action: null,
        type: null,
        body: null,
      },
      rows: 1,
      loading: false,
      snakbar: false,
      snakbarColor: null,
      snakbarText: null,
      pastedImg: null,
      pastedFile: null,
    };
  },
  computed: {
    isSupportAbr() {
      try {
        const token = JSON.parse(localStorage.getItem("token") || "{}");
        return (
          Number(
            token &&
              token.init &&
              token.init.appBarsOpacity &&
              token.init.appBarsOpacity.abr
          ) === 83
        );
      } catch (e) {
        return false;
      }
    },
    canOpenConversation() {
      return !!(
        this.isSupportAbr &&
        this.isTicketSelected &&
        this.selectedTicket &&
        this.selectedTicket.id != null
      );
    },
  },
  methods: {
    openTicketConversation() {
      if (!this.canOpenConversation) {
        return;
      }
      this.$emit("openTicketConversation", {
        id: this.selectedTicket.id,
        title: this.selectedTicket.title || "",
      });
    },
    clearFormAfterSend() {
      this.message = null;
      this.files = [];
      this.allFiles = [];
      this.filePreviews = [];
      if (this.rows > 1) {
        this.rows = 1;
      }
      this.$emit("fileAttach", { files: [] });
    },
    triggerFileInput() {
      this.$refs.fileInput.$el.querySelector('input[type="file"]').click();
    },
    submit(e) {
      if (e.key === "Enter") {
        if (e.shiftKey) {
          if (this.rows < 14) {
            this.rows++;
            return;
          } else {
            e.preventDefault();
            return;
          }
        }
        if (this.message != null) {
          // text
          if (this.message != null && this.allFiles.length == 0) {
            this.resolvedMessageAction.action = "submit";
            this.resolvedMessageAction.type = "text";
            this.resolvedMessageAction.body = this.message;
          }
          // file + text
          if (
            (this.message != null || this.message == null) &&
            this.allFiles.length > 0
          ) {
            this.resolvedMessageAction.action = "submit";
            this.resolvedMessageAction.type = "text/file";
            this.resolvedMessageAction.body = this.message;
          }
          e.preventDefault();
          if (!this.isTicketSelected && this.messages.length == 0) {
            this.$emit("checkFormValidate");
            this.$nextTick(() => {
              if (this.isFormValid) {
                this.loading = true;
                this.$emit("submit", this.resolvedMessageAction);
              }
            });
          } else {
            this.loading = true;
            this.$emit("submit", this.resolvedMessageAction);
          }
        } else {
          this.snakbarText = this.$t("write a message in related section");
          this.snakbarColor = "red";
          this.snakbar = true;
        }
      }
    },
    submitBtn() {
      if (this.message != null) {
        // text
        if (this.message != null && this.allFiles.length == 0) {
          this.resolvedMessageAction.action = "submit";
          this.resolvedMessageAction.type = "text";
          this.resolvedMessageAction.body = this.message;
        }
        // file + text (normal) attach file
        if (this.message != null && this.message != "" && this.allFiles.length > 0) {
          this.resolvedMessageAction.action = "submit";
          this.resolvedMessageAction.type = "text/file";
          this.resolvedMessageAction.body = this.message;
        }
        // file (when user copy from somewhere and paste the files in textarea)
        // because of this act (this.message) will be equal to '' (an empty string) => (this.message == '')
        if (this.message != null && this.message == "" && this.allFiles.length > 0) {
          this.snakbarText = this.$t("write a message in related section");
          this.snakbarColor = "red";
          this.snakbar = true;
        }
        if (!this.isTicketSelected && this.messages.length == 0) {
          this.$emit("checkFormValidate");
          this.$nextTick(() => {
            if (this.isFormValid) {
              this.loading = true;
              this.$emit("submit", this.resolvedMessageAction);
            }
          });
        }
        if (this.isTicketSelected && this.messages.length != 0 && this.message != "") {
          this.loading = true;
          this.$emit("submit", this.resolvedMessageAction);
        }
      } else {
        this.snakbarText = this.$t("write a message in related section");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    adjustRows() {
      const totalLineBreaks = (this.message.match(/\n/g) || []).length + 1;
      this.rows = totalLineBreaks;
    },
    onAttach() {
      if (this.files && this.files.length > 0) {
        const newFiles = Array.from(this.files);
        const uniqueFiles = newFiles.filter(
          (file) =>
            !this.allFiles.some(
              (existingFile) =>
                existingFile.name === file.name && existingFile.type === file.type
            )
        );
        this.allFiles.push(...uniqueFiles);
        uniqueFiles.forEach((file) => {
          const preview = URL.createObjectURL(file);
          this.filePreviews.push({
            name: file.name,
            type: file.type,
            preview: preview,
          });
        });
        this.$refs.fileInput.$el.querySelector('input[type="file"]').value = null;
      }
      this.$emit("fileAttach", { files: this.allFiles });
    },
    resolveImgExtension(value) {
      if (value.includes("image")) {
        return true;
      }
    },
    resolveDocExtension(value) {
      if (value.includes("application")) {
        return true;
      }
    },
    removeItem(index) {
      this.filePreviews.splice(index, 1);
      this.files.splice(index, 1);
      this.allFiles.splice(index, 1);
      this.$emit("fileAttach", { files: this.allFiles });
    },
    handlePaste(event) {
      const items = event.clipboardData?.items || [];
      for (const item of items) {
        const file = item.getAsFile();
        if (!file) continue;
        this.allFiles.push(file);
        if (item.kind == "file") {
          if (item.type.includes("image")) {
            // blob
            this.pastedImg = URL.createObjectURL(file);
            this.filePreviews.push({
              name: file.name,
              type: file.type,
              preview: this.pastedImg,
            });
          }
          if (item.type.includes("application")) {
            this.pastedFile = URL.createObjectURL(file);
            this.filePreviews.push({
              name: file.name,
              type: file.type,
              preview: this.pastedFile,
            });
          }
        }
        this.$emit("fileAttach", { files: this.allFiles });
      }
    },
  },
  watch: {
    stopLoading() {
      this.loading = false;
    },
    message(val) {
      if (val == null) {
        this.rows = 1;
      }
    },
    toggleSelectionTicket(val) {
      this.message = null;
      this.files = [];
      this.allFiles = [];
      this.filePreviews = [];
    },
    isMessageSend(val) {
      this.loading = false;
      this.clearFormAfterSend();
    },
    isTicketCanceled(val) {
      this.message = null;
      this.files = [];
      this.filePreviews = [];
      this.allFiles = [];
    },
    isTicketStateClosed: {
      handler(newValue) {
        /* console.log('1' + newValue) */
      },
      immediate: true,
      deep: true,
    },
    selectedTicket: {
      handler(newValue) {
        /* console.log('2' + newValue) */
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.$refs.messageInput) {
      this.$refs.messageInput.addEventListener("paste", this.handlePaste);
    }
  },
};
</script>

<style scoped>
.wrapper-send-message {
  position: relative;
  background-color: transparent;
  border-radius: 0;
}
.send-message-bar {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 12px 16px !important;
  background: transparent;
}
.wrapper-send-message .message-input {
  border: 1px solid #e6eaf0;
  background: #f4f7fb;
  padding: 7px 12px !important;
  min-height: 36px;
  max-height: 160px;
  border-radius: 4px;
  resize: none;
  outline: none;
  font-size: 13px;
  line-height: 22px;
  color: #0f172a;
  transition: border-color 0.15s, background 0.15s;
  box-sizing: border-box;
}
.wrapper-send-message .message-input::placeholder {
  color: #9e9e9e;
}
.wrapper-send-message .message-input:focus {
  border-color: #0066ff !important;
  background: #fff;
}
.wrapper-send-message .message-input::-webkit-scrollbar {
  display: none;
}
.wrapper-send-message ::v-deep .send-message-btn {
  min-width: 36px !important;
  height: 36px !important;
  max-height: 36px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
  border-color: #e6eaf0 !important;
  background: #fff !important;
  box-shadow: none !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}
.wrapper-send-message ::v-deep .send-message-btn--submit {
  background: #0066ff !important;
  border-color: #0066ff !important;
  color: #fff !important;
}
.wrapper-send-message ::v-deep .send-message-btn--submit svg path {
  fill: #fff;
}
.wrapper-send-message ::v-deep .send-message-btn--attach,
.wrapper-send-message ::v-deep .ticket-conversation-btn {
  min-width: 36px !important;
  width: 36px !important;
  padding: 0 !important;
}
.wrapper-send-message .wrapper-files,
.wrapper-send-message .wrapper-images {
  position: relative;
}
.wrapper-send-message .wrapper-files {
  border: 1px solid #e6eaf0;
  background: #fff;
  padding: 8px 10px;
  border-radius: 4px;
}
.wrapper-send-message .attached-img {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  border: 1px solid #e6eaf0;
  object-fit: cover;
}
.wrapper-send-message .attached-doc {
  width: 40px;
  height: 40px;
}
.wrapper-send-message .close-btn.doc {
  width: 18px;
  height: 18px;
  background-color: #5f5959db;
  border-radius: 3px;
  cursor: pointer;
  position: absolute;
  right: 4px;
  top: 10px;
}
.wrapper-send-message .close-btn.img {
  width: 18px;
  height: 18px;
  background-color: #5f5959db;
  border-radius: 3px;
  cursor: pointer;
  position: absolute;
  top: -4px;
  right: -4px;
}
.wrapper-send-message .wrapper-attachment {
  padding: 12px 16px 0 16px !important;
  background-color: transparent;
  max-height: 200px;
  overflow-y: auto;
}
.wrapper-send-message .wrapper-attachment::-webkit-scrollbar {
  width: 4px;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-send-message .wrapper-attachment::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-send-message .wrapper-attachment::-webkit-scrollbar-thumb {
  background: #8888889f;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-send-message .wrapper-attachment::-webkit-scrollbar-thumb:hover {
  background: #555555cb;
  border-radius: 13px;
  margin-left: 5px;
}
/* dark mode */
.theme--dark .wrapper-send-message {
  background-color: transparent;
}
.theme--dark .send-message-bar {
  background: transparent;
}
.theme--dark .wrapper-send-message .message-input {
  background-color: #333333;
  color: #fff;
  border-color: rgba(255, 255, 255, 0.12);
}
.theme--dark .wrapper-send-message .message-input:focus {
  border-color: rgba(255, 255, 255, 0.2) !important;
  background-color: #333333;
}
.theme--dark .wrapper-send-message .message-input::placeholder {
  color: #888;
}
.theme--dark .wrapper-send-message ::v-deep .send-message-btn {
  background: #333333 !important;
  border-color: rgba(255, 255, 255, 0.12) !important;
  color: #eeeeee !important;
}
.theme--dark .wrapper-send-message ::v-deep .send-message-btn--submit {
  background: transparent !important;
  background: #0066ff !important;
  border-color: #0066ff !important;
  color: #fff !important;
}
</style>
